import apiClient from "./apiClient";

const companiesApi = {
  getCompanyDirectory: async (params, signal) => {
    const response = await apiClient.get("/companies/directory", { params, signal });
    return response.data;
  },
  // 📌 Obtener todas las empresas
  getCompanies: async () => {
    try {
      const response = await apiClient.get("/companies");
      return response.data;
    } catch (error) {
      console.error("Error obteniendo empresas:", error);
      throw error;
    }
  },

  // 📌 Obtener una empresa por ID
  getCompanyById: async (companyId) => {
    try {
      const response = await apiClient.get(`/companies/${companyId}`);
      return response.data;
    } catch (error) {
      console.error("Error obteniendo empresa:", error);
      throw error;
    }
  },

  // 📌 Obtener el complianceURL de un PDF por encuesta
  getCompanySurveyPdf: async (companyId, surveyName) => {
    try {
      const response = await apiClient.get(
        `/companies/${companyId}/${surveyName}`
      );
      return response.data; // { complianceURL: "..." }
    } catch (error) {
      console.error(
        `Error obteniendo PDF para empresa ${companyId}, encuesta ${surveyName}:`,
        error
      );
      throw error;
    }
  },

  // 📌 Crear una nueva empresa
  createCompany: async (companyData) => {
    try {
      const response = await apiClient.post("/companies", companyData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      return response.data;
    } catch (error) {
      console.error("Error creando empresa:", error);
      throw error;
    }
  },

  // 📌 Actualizar una empresa
  updateCompany: async (companyId, updatedData) => {
    try {
      const response = await apiClient.put(
        `/companies/${companyId}`,
        updatedData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error actualizando empresa:", error);
      throw error;
    }
  },

  completeConfiguration: async (companyId) => {
    const response = await apiClient.patch(`/companies/${companyId}/configuration/complete`);
    return response.data;
  },

  // 📌 Eliminar una empresa (borrado lógico)
  deleteCompany: async (companyId) => {
    try {
      const response = await apiClient.delete(`/companies/${companyId}`);
      return response.data;
    } catch (error) {
      console.error("Error eliminando empresa:", error);
      throw error;
    }
  },

  // 📌 Obtener todas las empresas marcadas como eliminadas
  getDeletedCompanies: async () => {
    try {
      const response = await apiClient.get("/companies/deleted");
      return response.data;
    } catch (error) {
      console.error("Error obteniendo empresas eliminadas:", error);
      throw error;
    }
  },

  // 📌 Restaurar una empresa y sus datos relacionados
  restoreCompany: async (companyId) => {
    try {
      const response = await apiClient.patch(`/companies/${companyId}/restore`);
      return response.data;
    } catch (error) {
      console.error("Error restaurando empresa:", error);
      throw error;
    }
  },

  // 📌 Activar/Desactivar un cuestionario de una empresa
  toggleSurvey: async (companyId, surveyName, active) => {
    try {
      const response = await apiClient.patch(
        `/companies/${companyId}/surveys/${surveyName}`,
        { active }
      );
      return response.data;
    } catch (error) {
      console.error("Error toggling survey:", error);
      throw error;
    }
  }
};

export default companiesApi;
